import { render, staticRenderFns } from "./RequirementBtns.vue?vue&type=template&id=aa1c0b18&"
import script from "./RequirementBtns.vue?vue&type=script&lang=js&"
export * from "./RequirementBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports